import { createSlice } from '@reduxjs/toolkit';
import { fetchEspDiagnosisData } from '../../services/well-diagnosis/WellDiagnosisService';

interface WellDiagnosisState {
  espDiagnosis: {
    data: any | null;
    loading: boolean;
    error: string | null;
  };
}

const initialState: WellDiagnosisState = {
  espDiagnosis: {
    data: null,
    loading: false,
    error: null,
  },
};

const WellDiagnosisSlice = createSlice({
  name: 'wellDiagnosis',
  initialState,
  reducers: {
    clearDiagnosisData: (state) => {
      state.espDiagnosis = { data: null, loading: false, error: null };
    },
  },
  extraReducers: (builder) => {
    // Fetch well diagnosis data
    builder
      .addCase(fetchEspDiagnosisData.pending, (state) => {
        state.espDiagnosis.loading = true;
        state.espDiagnosis.error = null;
      })
      .addCase(fetchEspDiagnosisData.fulfilled, (state, action) => {
        state.espDiagnosis.loading = false;
        state.espDiagnosis.data = action.payload;
        state.espDiagnosis.error = null;
      })
      .addCase(fetchEspDiagnosisData.rejected, (state, action) => {
        state.espDiagnosis.loading = false;
        state.espDiagnosis.error = action.error.message || 'Failed to fetch diagnosis data';
        state.espDiagnosis.data = null;
      });
  },
});

export const { clearDiagnosisData } = WellDiagnosisSlice.actions;

export default WellDiagnosisSlice.reducer;
